<template>
  <div class="recipe_add">
    <br />

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: 'SignCheck' }">申请处方</el-breadcrumb-item>
      <el-breadcrumb-item>申请处方</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="申请处方" name="first">
        <el-container>
          <el-header>
            <!-- 空置区域  -->
          </el-header>
          <el-main>
            <div class="form-region-header font-30">提交首诊药品</div>
            <table style="width: 100%">
              <tr>
                <td>
                  <el-table :data="drugInfoTableData" style="width: 100%">
                    <el-table-column prop="drug_name" label="药品名称" width="120"></el-table-column>
                    <el-table-column prop="specification" label="规格" width="100"></el-table-column>
                    <el-table-column label="用法" width="92">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.usewayVal" value="口服" width="52" size="mini">
                          <el-option
                            v-for="item in scope.row.useWays"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="用量" width="200px">
                      <template slot-scope="scope">
                        <div style="display:inline-block">
                          <label style="float:left">每日 </label>
                          <el-input
                            style="float:left ;width:50px"
                            v-model="scope.row.freqency"
                            size="mini"

                          ></el-input>
                          <label style="float:left">  次，</label>
                          <br />  <br />

                          <label style="float:left">每次</label>
                          <el-input
                            style="float:left;width:50px"
                            v-model="scope.row.numPerTime"
                            size="mini"
                          ></el-input>

                          <el-select
                            style="float:left;width:70px"
                            v-model="scope.row.unitVal"
                            height="30"
                            width="60"
                            size="mini"
                          >
                            <el-option
                              v-for="item in scope.row.unit"
                              :key="item.value"
                              :label="item.label"
                              :value="item.label"
                            ></el-option>
                          </el-select>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数量" width="125px">
                      <template slot-scope="scope">
                        <div style="display:inline-block">

                        <el-input
                          style="float:left;width:45px;left:-10px"
                          v-model="scope.row.quantity"
                          size="mini"
                        ></el-input>
                        <el-select v-model="scope.row.volumnVal" style="width:60px;left:-10px" size="mini">
                          <el-option
                            v-for="item in scope.row.volumn"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          ></el-option>
                        </el-select>
                       <!--<label style="float:left;width=20px">盒</label>-->
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否用过">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.usedbeforeVal" style="width:70px" size="mini">
                          <el-option
                            v-for="item in scope.row.usedbefore"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                          ></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="取消">
                      <template slot-scope="scope">
                        <el-button  size="mini" @click="removeDetailRow(scope.row)">取消</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </td>
              </tr>
              <tr>
                <td>
                  <el-button @click="gotomodify">上一步</el-button>
                  <el-button type="primary" @click="onSubmitRecipe">申请处方</el-button>
                </td>
              </tr>
            </table>
          </el-main>
          <el-main>
            <div class="form-region-header font-30">查询首诊药品</div>
            <div>
              <el-form :inline="true" :model="formModels" class="demo-form-inline">
                <el-form-item label="首诊药品名称">
                  <el-input v-model="formModels.medicineName" placeholder="请输入首诊药品名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onQueryDrug">查询</el-button>
                </el-form-item>
              </el-form>

              <el-table :data="drugQueryData" style="width: 100%">
                <el-table-column prop="drug_name" label="药品名称" width="200"></el-table-column>
                <el-table-column prop="specification" label="规格" width="200"></el-table-column>
                <el-table-column label="选择">
                  <template slot-scope="scope">
                    <el-button @click="selectDrugs(scope.row)">选取</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-main>
        </el-container>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import qs from "qs";

Array.prototype.indexOf = function(val) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};

Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

export default {
  name: "submitRecipe",
  data() {
    return {
      activeName: "first",

      recipeID: "",

      formModels: {
        medicineName: ""
      },

      useWays: [
        { value: 1, label: "口服" },
        { value: 2, label: "外用" },
        { value: 3, label: "外敷" },
        { value: 4, label: "注射" },
        { value: 5, label: "其他" }
      ],

      DrugUnit: [
        { value: 1, label: "粒" },
        { value: 2, label: "片" },
        { value: 3, label: "袋" },
        { value: 4, label: "包" },
        { value: 5, label: "滴" },
        { value: 6, label: "毫升" },
        { value: 7, label: "克" },
        { value: 8, label: "毫克" },
        { value: 9, label: "颗" },
        { value: 10, label: "喷" },
        { value: 11, label: "揿" },
        { value: 12, label: "丸" },
        { value: 13, label: "贴" },
        { value: 14, label: "枚" },
        { value: 15, label: "支" },
        { value: 16, label: "IU" }
      ],

      volumn: [{ value: 1, label: "盒" }, { value: 2, label: "剂" }],

      usedBefore: [{ value: 1, label: "是" }, { value: 0, label: "否" }],

      drugQueryData: [],
      //generate by onQueryDrug
      // drugQueryData Definition
      // drugQueryData : [{drug_id: ?n? ,drug_name:?""?,specification: ?""?  }]

      // drugInfoTableData Definition
      //drugInfoTableData: [{drug_id: ?,drug_name: ?,,specification: ?"", useWays: this.useWays ,useway: ? , freqency:? , numPerTime:? , unit:this.DrugUnit , quantity:? , usedbefore:this.usedBefore}],

      drugInfoTableData: [],

      formBinds: {},
      requestDrugInfoAPI: "https://yc.suyizaixian.com:30005/requestDrugInfo",
      createRecipeAPI: "https://yc.suyizaixian.com:30005/createRecipe",
      rules: {
        name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        medicine: [
          { required: true, message: "请选择药品名字", trigger: "change" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    selectDrugs(row) {
      let drugInfo = JSON.parse(JSON.stringify(row));
      drugInfo.useWays = this.useWays;
      drugInfo.usewayVal = "口服";
      drugInfo.freqency = "";
      drugInfo.numPerTime = "";
      drugInfo.unit = this.DrugUnit;
      drugInfo.unitVal = "粒";
      drugInfo.quantity = "";
      drugInfo.usedbefore = this.usedBefore;
      drugInfo.usedbeforeVal = "是";
      drugInfo.volumnVal="盒";
      drugInfo.volumn=this.volumn;
      this.drugQueryData.remove(row);
      this.drugInfoTableData.push(drugInfo);
    },

    removeDetailRow(row) {
      this.drugInfoTableData.remove(row);
    },

    gotomodify() {
      this.$router.replace("/RecipeAdd2");
    },

    onSubmitRecipe() {
      let datas = {};

      datas.recipeID = this.recipeID;
      datas.authToken = sessionStorage.getItem("authToken")

      let drugInfoArray = [];

      let hasEmpty = 0;
      this.drugInfoTableData.forEach(item => {
        if (
          item.freqency.trim() == "" ||
          item.numPerTime.trim() == "" ||
          item.quantity.trim() == ""
        )
          hasEmpty = 1;
        let drugInfoobj = {};
        drugInfoobj.drugDetailID = item.drug_id;
        this.useWays.forEach(eachUseWay => {
          if (eachUseWay.label == item.usewayVal) {
            drugInfoobj.useway = eachUseWay.value;
          }
        });
        drugInfoobj.freqency = Number(item.freqency.trim());
        drugInfoobj.numPerTime = Number(item.numPerTime.trim());
        drugInfoobj.quantity = Number(item.quantity.trim());

        this.DrugUnit.forEach(eachUnit => {
          if (eachUnit.label == item.unitVal) {
            drugInfoobj.unit = eachUnit.value;
          }
        });

        this.usedBefore.forEach(eachBefore => {
          if (eachBefore.label == item.usedbeforeVal) {
            drugInfoobj.usedbefore = eachBefore.value;
          }
        });
        this.volumn.forEach(eachVol => {
          if (eachVol.label == item.volumnVal) {
            drugInfoobj.volumn = eachVol.value;
          }
        });
        if(drugInfoobj.volumn!=1&&drugInfoobj.volumn!=2){
          drugInfoobj.volumn=1;
        }
        drugInfoArray.push(drugInfoobj);
      });
      if (drugInfoArray.length <= 0) {
        alert("请选择药品");
      } else if (hasEmpty) {
        alert("请正确填写药品用法");
      } else {
        //console.log(drugInfoArray);
        datas.DrugInfo = drugInfoArray;

        this.$confirm("是否确定提交处方?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.axios.post(this.createRecipeAPI, qs.stringify(datas)).then(response => {
              let res = response.data;
              console.log(res);
              if (res.data.result == "success") {
                this.$router.replace("/Audit");
              } else if (res.data.result == "fail") {
                alert(res.data.err.code);
              }
            });
          }).catch((e) => { });
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    onQueryDrug(formName) {
      console.log(formName);
      if (this.formModels.medicineName.trim() == "") {
        alert("请输入药品名称");
      } else {
        let datas = {
          drugName: this.formModels.medicineName,
          authToken: sessionStorage.getItem("authToken")
          };

        this.axios
          .post(this.requestDrugInfoAPI, qs.stringify(datas))
          .then(response => {
            let res = response.data;
            console.log(res);
            if (res.data.result == "success") {
              var druglist = res.data.drug_list;

              console.log("druglist is:");
              console.log(druglist);
              //druglist.forEach(item => {item.checked = false;});

              this.drugQueryData = druglist;
            } else if (res.data.result == "fail") {
              alert(res.data.err.code);
            }
          }).catch((e) => { alert(e+"，登录超时，请重新登录");});
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    this.recipeID = sessionStorage.getItem("recipeID");
    //！！！！！！
    //this.recipeID = 1;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
